import { css } from 'styled-components';
import { PrimaryPath, SecondaryPath } from '../IndicatorBase/IndicatorBase.styles.js';

const ProgressStyle = css `
    color: ${({ theme }) => { var _a; return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.SDS_BRAND_COLOR_ELEMENT_STRONG_PRIMARY; }};
    transform: ${({ type }) => (type === 'circle' ? 'rotate(270deg)' : 'none')};

    /* Stylelint is unable to resolve styled component names used in styles below */
    /* stylelint-disable no-duplicate-selectors */

    ${PrimaryPath} {
        color: currentcolor;
    }

    ${SecondaryPath} {
        color: currentcolor;
        opacity: ${({ track }) => (track ? 0.22 : 0)};
        stroke-dasharray: none;
    }
`;

export { ProgressStyle };
//# sourceMappingURL=Progress.styles.js.map
